import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useFormik } from "formik";
// import * as Yup from "yup";
import axios from "axios";
import { baseURL, baseURL1 } from "../../../Redux/baseURL";
import $ from "jquery";
import {
  about_loading,
  generate_employer_about,
  getting_employer_profile_successful,
} from "../../../Redux/ActionCreator";
import LoaderModal from "../../../components/LoaderModal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import {
  getAllMyCv,
  googleSuccess,
  userName_from_db,
  postUserProfile,
  getProfile,
  clearStoredValue,
  clearPS,
  login_success,
  existing_resume_features,
} from "../../../Redux/ActionCreator";

import { LanguageContext } from "../../global/languageContext";


function EmployerForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const abt_stat = useSelector((e) => e.about);
  const [click, setClick] = useState(false);
  const URL = window.location.pathname;
  const employer = useSelector(e=> e.employer)
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const userName = useSelector((prev) => prev.userInfo);
  const [name, setName] = useState("");
  const my_name = userName.user;
  const [about, setAbout] = useState("");
  const [ error, setError ] = useState("");
  const profile = useSelector((prev) => prev.profile);
  const params = new URLSearchParams(window.location.search).get("token");
  const profile_stat = new URLSearchParams(window.location.search).get(
    "profile_status"
  );
  const acctType = new URLSearchParams(window.location.search).get("AcctType");
  const myCvs = useSelector((prev) => prev.saved_cv);
  // initialize useSelector and useDispatch
  console.log("params", params);
  console.log("profile status", profile_stat);
  console.log("Accct Type", acctType);

  
useEffect(()=>{
 if (employer.message !== null) {
    $('[name="name"]').val(employer.message.name)
    $('[name="email"]').val(employer.message.email);
    $('[name="type_of_business"]').val(employer.message.type_of_business);
    $('[name="phone_number"]').val(employer.message.phone_number),
    $('[name="info"]').val(employer.message.info);
    setAbout(employer.message.about)
    $('[name="no_of_employees"]').val(employer.message.no_of_employees);
    $('[name="pay_structure"]').val(employer.message.pay_structure);

    $('[name="opening"]').val(
      employer.message.hours.opening
    );
    $('[name="closing"]').val(
      employer.message.hours.closing
    );
    $('[name="Employer_Identification_Number"]').val(
      employer.message.Employer_Identification_Number
    );

    $('[name="city"]').val(
      employer.message.location.city
    );
      $('[name="state"]').val(
      employer.message.location.state
    );
      $('[name="country"]').val(
      employer.message.location.country
    );
      $('[name="zipcode"]').val(
      employer.message.location.zipcode
    );

       
 }
   }, [employer.message])

  // called an authenticate function to verify user that logged in with linkedin and google;
  useEffect(() => {
    dispatch(clearStoredValue());
    dispatch(clearPS());

    // if (my_name !== null) {
    // 	setName(my_name.name);
    // }
    const token = localStorage.getItem("token");
    if (token === null) {
      localStorage.setItem("token", params);
      dispatch(userName_from_db(params));
      dispatch(getAllMyCv(params));
      dispatch(
        googleSuccess({ profile_status: profile_stat, AcctType: acctType })
      );
      dispatch(
        login_success({ profile_status: profile_stat, AcctType: acctType })
      );
      dispatch(postUserProfile(params));
      dispatch(getProfile(params));
    } else {
      if (profile.message === null || profile.message === undefined) {
        dispatch(getProfile(token));
      }
    }
  }, [my_name]);

  // useEffect(() => {
  // 	const token = localStorage.getItem('token');
  // 	if (userName.user === null) {
  // 		dispatch(userName_from_db(token));
  // 	}
  // }, [])

  useEffect(() => {
    if (abt_stat.message !== null) {
      $('[name="about"]').val(abt_stat.message);
      setAbout(abt_stat.message);
    }
  }, [abt_stat.message]);


  /*   const handleSubmit = () => {
    const obj = {
      name: $('[name=""]').val(),
      email: $('[name=""]').val(),
    }
  } */
  const handleAboutGeneration = () => {
    setClick(true);
    console.log("About", $('[name="about"]').val());
    dispatch(
      generate_employer_about({
        about: $('[name="about"]').val(),
        name: $('[name="name"]').val(),
      })
    );
  };


  
  function HandleSubmit(e, values) {
    e.preventDefault()
  if (abt_stat.message !== null) {
    setAbout(abt_stat.message);
  } else {
    setAbout($('[name="about"]').val());
  }
  console.log("About:", about);

    let body = {
    name:  $('[name="name"]').val(),
      email:     $('[name="email"]').val(),
        type_of_business:  $('[name="type_of_business"]').val(),
          
          phone_number: $('[name="phone_number"]').val(),
          info: $('[name="info"]').val(),
        about: about,
          no_of_employees: $('[name="no_of_employees"]').val(),
            pay_structure: $('[name="pay_structure"]').val(),
            hours: {
              opening: $('[name="opening"]').val(),
              closing: $('[name="closing"]').val(),
            },
          Employer_Identification_Number: $('[name="Employer_Identification_Number"]').val(),
          location: {
            city:  $('[name="city"]').val(),
            state:  $('[name="state"]').val(),
            country:  $('[name="country"]').val(),
            zipcode: $('[name="zipcode"]').val(),
          }
    };

    if (URL === "/user/employer/form/update") {
      let token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };


      fetch(baseURL + "/api/employer/update_profile", {
        method: "PATCH",
        body: JSON.stringify(body),
        headers,
      })
        .then((resp) => resp.json())
        .then((resp) => {
          console.log(resp);
          if (resp.success === true) {

            dispatch(getting_employer_profile_successful(resp.data));
            
            console.log("body string", resp.data);
            navigate("/user/employer/profile");
          }
        });
    } else {
        console.log("body", body);
        let token = localStorage.getItem("token");
        console.log("body", body);

        // const headers = {
        //   "Content-Type": "application/json",
        //   'Authorization': `Bearer ${token}`,
        // };

        fetch(baseURL + "/api/employer/create_employer_profile", {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
          .then((resp) => resp.json())
          .then((resp) => {
            console.log(resp);
            if (resp.success === true) {
              window.location.assign(baseURL1 + "/user/employer/profile");
            }
            if (resp.title === "Duplicate Field") {
              let err;
              if (resp.message.includes("_")) {
                err = resp.message.replace("_", " ");
                setError(err);
              } else {
                setError(resp.message);
              }
            }
          });
      };
    
  }

  console.log("employer", employer)


  //   const [phoneNumber, setPhoneNumber] = useState("");

  //   const handlePhoneNumberChange = (value) => {
  //     setPhoneNumber(value);
  //   };

  //   BigSam
  //   onSubmit: useEffect(() => {

  return (
    <div>
      <form
        className="tablet:px-[2.5%] w-full px-2 sm:px-5 h-full overflow-y-hidden tablet:mx-auto"
        onSubmit={(e,value)=>HandleSubmit(e,value)}
      >
        <div className="tablet:w-full bg-transparent border-2 border-[#D1D3F7] rounded-full px-6 py-[0.375rem] font-semibold tablet:text-3xl text-base text-black mt-6">
          Business Profile
        </div>
        <p className="w-full my-12 tablet:text-base tablet:font-medium text-sm">
          Complete this form create an employer or business profile.
        </p>

        {/* Main content of page  */}
        <div className="bg-[#FEFEFE] w-full rounded-2xl border-2 border-[#D1D3F7] flex flex-col justify-center gap-16 tablet:px-16 px-6 py-8">
          {/* company info button  */}
          <div className="w-full flex">
            <p className="bg-[#FED1C1] px-7 py-3 font-medium text-lg text-black rounded-full whitespace-nowrap">
              Company Information
            </p>
          </div>

          <ul className="list-disc flex flex-col gap-16">
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  What's your business name?
                </p>
                <p className=" font-medium text-xs text-[#FF6633]">
                  For verification purposes, please use only the name by which
                  your business is registered.
                </p>
                <input
                  type="text"
                  name="name"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Business name here"
                  // value={formikform.values.name}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  What's your business type?
                </p>
                <p className=" font-medium text-xs text-[#FF6633]">
                  Please specify the type of business you run, for example,
                  “Construction Company.”
                </p>
                <input
                  type="text"
                  name="type_of_business"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Business type here"
                  // value={formikform.values.type_of_business}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  What's your Employer Identification Number (EIN)?
                </p>
                <p className=" font-medium text-xs text-[#FF6633]">
                  For verification purposes.
                </p>
                <input
                  type="text"
                  name="Employer_Identification_Number"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Identification number here"
                  // value={formikform.values.Employer_Identification_Number}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  What does your business do?
                </p>
                <p className=" font-medium text-xs text-[#FF6633]">
                  In your own words describe what your business is about. For
                  example, how long have you been in business? What type of
                  business are you?
                </p>
                <p className=" font-medium text-xs text-[#FF6633] mb-2">
                  Click on ‘Generate’ if you want our technology to rephrase
                  your words better.
                </p>
                <textarea
                  className=" h-56 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] px-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal placeholder:align-top"
                  placeholder="0/300"
                  type="text"
                  name="type_of_business"
                  value={about}
                  onChange={(e) => setAbout(e.target.value)}
                  // onBlur={formikform.handleBlur}
                />
                <div>
                  <imput
                    type="button"
                    onClick={handleAboutGeneration}
                    className="text-base font-medium bg-[#FF6633] rounded-full px-5 py-3 text-white"
                  >
                    Generate
                  </imput>
                </div>
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  Where is your business located?
                </p>
                <p className=" font-medium text-base text-[#B1B0B0]">
                  Enter your street address city and state below
                </p>
                <input
                  type="text"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="City here"
                  name="city"
                  // value={formikform.values.city}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
                <input
                  type="text"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="State here"
                  name="state"
                  // value={formikform.values.state}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
                <input
                  type="text"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Country here"
                  name="country"
                  // value={formikform.values.country}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
                <input
                  type="text"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Zip Code here"
                  name="zipcode"
                  // value={formikform.values.zipcode}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  How many people work with you?
                </p>
                <input
                  type="text"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Enter a number here"
                  name="no_of_employees"
                  // value={formikform.values.no_of_employees}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  How can customers reach you?
                </p>
                {/*               <p className=" font-medium text-xs text-[#FF6633]">
                Enter your business phone number here and click on “Verify
                Phone”.
              </p> */}
                <input
                  type="text"
                  placeholder="Enter phone number"
                  // value={phoneNumber}
                  // onChange={handlePhoneNumberChange}
                  defaultCountry="US" // Set the default country code (e.g., US)
                  // Specify the allowed countries
                  name="phone_number"
                  // value={formikform.values.phone_number}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />

                {/*               <div className="flex justify-center items-center gap-4 border-l-8 border-[#FF6633] bg-[#FBE5C1] py-2 px-4 text-base font-normal ">
                <svg
                  width="22"
                  height="19"
                  viewBox="0 0 22 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z"
                    fill="#FF6633"
                  />
                </svg>

                <span>
                  You have to verify your phone number to post jobs on Moil.
                </span>
              </div> */}

                {/*               <div>
                <button className="text-base font-semibold rounded-xl px-5 py-4 bg-[#FF6633] text-white">
                  Verify Phone
                </button>
              </div> */}

                <p className=" font-medium text-xs text-[#FF6633]">
                  Enter your business email address below.
                </p>

                <input
                  type="text"
                  className=" h-14 w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                  placeholder="Email address here"
                  name="email"
                  // value={formikform.values.email}
                  // onChange={formikform.handleChange}
                  // onBlur={formikform.handleBlur}
                />
              </div>
            </li>
            <li>
              <div className="flex flex-col gap-2 tablet:w-[80%] w-full">
                <p className=" font-medium text-base text-[#171718]">
                  What are your business hours?
                </p>
                <p className=" font-medium text-xs text-[#FF6633]">
                  Select opening and closing time.
                </p>
                <div className="flex flex-col tablet:flex-row items-center tablet:justify-between gap-14">
                  <select
                    name="opening"
                    id="openingtime"
                    className=" h-14 w-[50%] xl:w-[50%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                    placeholder=""
                    // value={formikform.values.opening}
                    // onChange={formikform.handleChange}
                    // onBlur={formikform.handleBlur}
                  >
                    <option value="8am">8am</option>
                    <option value="9am">9am</option>
                    <option value="10am">10am</option>
                  </select>
                  <select
                    name="closing"
                    id="closingtime"
                    className=" h-14 w-[50%] xl:w-[50%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                    placeholder=""
                    // value={formikform.values.closing}
                    // onChange={formikform.handleChange}
                    // onBlur={formikform.handleBlur}
                  >
                    <option value="8pm">8pm</option>
                    <option value="9pm">9pm</option>
                    <option value="10pm">10pm</option>
                  </select>
                </div>
              </div>
            </li>

            <li>
              <div className="flex flex-col gap-2 w-[100%]">
                <p className=" font-medium text-base text-[#171718]">
                  How do you usually pay your employees? (Hourly, Salary, etc.)
                </p>
                <p className=" font-medium text-xs text-[#FF6633]">
                  Please check the box(es) that apply to you.
                </p>

                {/* checkboxes  */}
                <div className=" tablet:flex grid grid-cols-2 items-center gap-12">
                  <div className=" flex gap-3 items-center">
                    <input
                      type="checkbox"
                      className=" bg-white border border-[#5843BD] checked:bg-[#5843BD] focus:bg-transparent active:bg-[#5843BD] focus:outline-none outline-none checked:outline-none focus:ring-1 focus:ring-[#5843BD] focus:ring-opacity-50 appearance-none transition duration-150 ease-in-out fill-current w-[27px] h-[27px] rounded-md"
                    />
                    <label
                      htmlFor="checkbox"
                      className=" font-normal text-base"
                    >
                      Hourly
                    </label>
                  </div>
                  <div className=" flex gap-3 items-center">
                    <input
                      type="checkbox"
                      className=" bg-white border border-[#5843BD] checked:bg-[#5843BD] focus:bg-transparent active:bg-[#5843BD] focus:outline-none outline-none checked:outline-none focus:ring-1 focus:ring-[#5843BD] focus:ring-opacity-50 appearance-none transition duration-150 ease-in-out fill-current w-[27px] h-[27px] rounded-md"
                    />
                    <label
                      htmlFor="checkbox"
                      className=" font-normal text-base"
                    >
                      Salary
                    </label>
                  </div>
                  <div className=" flex gap-3 items-center">
                    <input
                      type="checkbox"
                      className=" bg-white border border-[#5843BD] checked:bg-[#5843BD] focus:bg-transparent active:bg-[#5843BD] focus:outline-none outline-none checked:outline-none focus:ring-1 focus:ring-[#5843BD] focus:ring-opacity-50 appearance-none transition duration-150 ease-in-out fill-current w-[27px] h-[27px] rounded-md"
                    />
                    <label
                      htmlFor="checkbox"
                      className=" font-normal text-base"
                    >
                      Others
                    </label>
                  </div>
                  <input
                    type="text"
                    className="  w-[100%] xl:w-[100%] 2xl:w-[70%] rounded-lg border border-[#D2D4F8] indent-4 placeholder:text-[#B3B3B3] text-base font-normal placeholder:text-base placeholder:font-normal"
                    placeholder="Specify "
                  />
                </div>
              </div>
            </li>
          </ul>
          <div className="flex items-center justify-center sm:flex xsm:block">
            {/* <div> */}
              <h6 className="text-sm text-red-500 text-base font-medium md:mr-auto ml:mr-auto xl:mr-auto xsm:w-full items-center xsm:text-center xsm:mb-3 ">{error}</h6>
            {/* </div> */}
            <div className="flex justify-center tablet:justify-end sm:w-full">
              <button
                className="text-white text-base font-semibold rounded-lg bg-[#5843BD] py-3 px-5 whitespace-nowrap"
                type="submit"
              >
                Save business profile
              </button>
            </div>
          </div>
        </div>
      </form>
      {click == true ? (
        <>
          {abt_stat.message !== null ? (
            setClick(false)
          ) : (
            <LoaderModal text="Generating standard introduction for your company" />
          )}
        </>
      ) : null}
    </div>
  );
}

export default EmployerForm;

